import React, { useEffect, useState } from "react";
import { Button, Stack } from "@mui/material";
import { useUpdateAction } from "../../hooks";
import {
  AUTHENTICATED_EMPLOYEE_JWT,
  DELETE_SELECTED_QUOTE,
  READY_TO_DISPATCH_STATUS,
  TRIGGER_SELECT_QUOTE,
} from "../../constants";

interface SelectedQuoteActionButtonsProps {
  data: any;
  onCloseDrawer: () => void;
}

export const SelectedQuoteActionButtons = ({ data, onCloseDrawer }: SelectedQuoteActionButtonsProps) => {
  const selectedRows = [data];

  const [actionUpdateRequest, setActionUpdateRequest] = useState({ requestAvailable: false, request: [] });

  const { successfullUpdatedAction, updateActionResponseData } = useUpdateAction({
    updateActionRequest: actionUpdateRequest.request,
    enabled: actionUpdateRequest.requestAvailable,
  });

  useEffect(() => {
    if (updateActionResponseData?.code === "UNAUTHORIZED") {
      localStorage.removeItem(AUTHENTICATED_EMPLOYEE_JWT);
      window.location.reload();
    }
  }, [updateActionResponseData]);

  const prepareActionUpdateRequest = (actionType: string) => {
    return {
      actionType: actionType,
      idList: selectedRows.map((orders) => orders.orderIds).flat(),
    };
  };

  const onSelectedQuoteButtonClick = (actionType: string) => {
    setActionUpdateRequest({ requestAvailable: true, request: [prepareActionUpdateRequest(actionType)] });
  };

  const handleRefreshSelectedQuote = () => {
    // console.log("Refresh selected quote");
    onSelectedQuoteButtonClick(TRIGGER_SELECT_QUOTE);
  };

  const handleDeleteSelectedQuote = () => {
    // console.log("Delete selected quote");
    onSelectedQuoteButtonClick(DELETE_SELECTED_QUOTE);
  };

  useEffect(() => {
    if (successfullUpdatedAction) {
      onCloseDrawer();
    }
  }, [successfullUpdatedAction, onCloseDrawer]);

  return (
    <Stack direction="row" spacing={2} padding={2} justifyContent="flex-start">
      <Button
        variant="outlined"
        color="primary"
        sx={{
          width: "fit-content", // Ensures button width fits content like in "Add criteria"
          border: "1px solid", // Box outline
          borderColor: "primary.main", // Same as button color
        }}
        onClick={handleRefreshSelectedQuote}
      >
        Refresh Selected Quote
      </Button>
      <Button
        variant="outlined"
        color="primary"
        sx={{
          width: "fit-content", // Ensures button width fits content like in "Add criteria"
          border: "1px solid", // Box outline
          borderColor: "primary.main", // Same as button color
        }}
        onClick={handleDeleteSelectedQuote}
      >
        Delete Selected Quote
      </Button>
    </Stack>
  );
};
